export default __webpack_public_path__ + "static/media/ev-banner.a61fa544.jpg";